
<div>
    <app-header></app-header>
 </div>
<div class="main">
    <!-- <div *ngIf="!myProfile" class="d-flex mb-3 back">
        <img (click)="goBack()" src="assets/images/arrow-circle-left.svg">
        <h3 (click)="goBack()" class="ms-2 mb-0">Back</h3>
    </div> -->
    <div Class="row m-0 ">
        <!-- <div class="col-lg-2 p-0 profile mt-0 position-relative">
            <app-profile-front-page></app-profile-front-page>
        </div> -->
        <div class="col-lg-12 bg-white py-sm-3 py-md-3 py-0">
            <!-- <app-menu-card></app-menu-card> -->
            <div class="upperimgdata bg-white">
                <div class="change-manage-notifications-container">
                    <div class="d-flex flex-column">
                        <h4>{{ licenseData.title || 'License' }}</h4>
                        <span><b class="bld-text">Settings<span class="mx-2">/</span></b><span class="semi-bld-text">{{
                                licenseData.title || 'License' }}</span></span>
                    </div>
                    <div class="lincese_content">
                        <div class="lincese">
                            <p class="mb-0">
                                <span>{{ licenseData.short_description || 'Loading full description...' }}</span>
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<div>
    <app-footer></app-footer>
</div>